module.exports = __webpack_public_path__ + "files/f7cb796274081ea7b5fc52933b9f4045.png";